import { useCallback, useEffect, useState } from 'react';

import { getStoredPreState, saveStoredPreState, clearStoredPreState } from '../utils/preStateStorage';

import { PreState } from '../organisms/LegalConsents/LegalConsents.types';

export function useConsentPreState() {
  const [preState, setPreState] = useState<PreState>();

  const [hasPreState, setHasPreState] = useState(false);

  useEffect(() => {
    const storedPreState = getStoredPreState();

    if (storedPreState) {
      setPreState(storedPreState);
      setHasPreState(true);
    }
  }, []);

  const savePreState = useCallback((preState: PreState) => {
    saveStoredPreState(preState);

    setPreState(preState);
    setHasPreState(true);
  }, []);

  const clearPreState = useCallback(() => {
    clearStoredPreState();

    setPreState({});
    setHasPreState(false);
  }, []);

  return {
    preState,
    hasPreState,
    savePreState,
    clearPreState,
  };
}
